module.exports = __webpack_public_path__ + "static/media/cardOutsourcing.032a308b.svg";